import {HttpInterceptorFn} from '@angular/common/http';
import {HttpErrorResponse} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {inject} from "@angular/core";
import {ConnectionUnavailableScreenService} from "../services/connection-unavailable-screen.service";
import {ServiceUnavailableScreenService} from "../services/service-unavailable-screen.service";
import {ToastService} from "../services/toast.service";
import {SKIP_ERROR_TOAST} from "../utils/http-context-tokens";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const connectionUnavailableScreenService = inject(ConnectionUnavailableScreenService);
  const serviceUnavailableScreenService = inject(ServiceUnavailableScreenService);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (connectionUnavailableScreenService.isConnectionUnavailableError(error)) {
        return throwError(() => error);
      }

      if (serviceUnavailableScreenService.isServiceUnavailableError(error)) {
        return throwError(() => error);
      }

      const skipToast = req.context.get(SKIP_ERROR_TOAST);

      if (!skipToast) {
        let message = 'Ein Fehler ist aufgetreten';
        let headline = 'Unerwarteter Fehler';

        if (error.status === 401) {
          localStorage.removeItem('accessToken');
          headline = 'Nicht autorisiert'
          message = 'Ihre Sitzung ist abgelaufen oder Sie haben keine gültigen Anmeldedaten. Bitte melden Sie sich erneut an.';
        } else {
          try {
            const parsed = typeof error.error === 'string' ? JSON.parse(error.error) : error.error;
            message = parsed?.title || parsed?.detail || message;
          } catch {
            // fallback message stays
          }
        }

        toastService.show(headline, message, 'error');
      }

      return throwError(() => error);
    })
  );
};
